import { DescriptionComponent } from './description.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ DescriptionComponent });
